// @ts-nocheck
import * as Types from '../../types/types';

import * as Operations from '../../queries';
import * as Apollo from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetPersonAvailableEmailsOrFaxesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetPersonAvailableEmailsOrFaxesQuery = {
  __typename?: 'Query';
  person?: {
    __typename?: 'Person';
    id: string;
    communicationData: {
      __typename?: 'CommunicationDataConnection';
      edges?: Array<{
        __typename?: 'CommunicationDataEdge';
        node?: {
          __typename?: 'CommunicationData';
          value?: string | null;
          communicationDataType: {
            __typename?: 'CommunicationDataType';
            baseType?: Types.CommunicationDataBaseType | null;
          };
        } | null;
      }> | null;
    };
    employments: {
      __typename?: 'EmploymentConnection';
      filteredCount: number;
      edges?: Array<{
        __typename?: 'EmploymentEdge';
        node?: {
          __typename?: 'Employment';
          id: string;
          oid: string;
          communicationData: {
            __typename?: 'CommunicationDataConnection';
            edges?: Array<{
              __typename?: 'CommunicationDataEdge';
              node?: {
                __typename?: 'CommunicationData';
                value?: string | null;
                communicationDataType: {
                  __typename?: 'CommunicationDataType';
                  baseType?: Types.CommunicationDataBaseType | null;
                };
              } | null;
            }> | null;
          };
        } | null;
      }> | null;
    };
    consents: {
      __typename?: 'PersonConsentConnection';
      edges?: Array<{
        __typename?: 'PersonConsentEdge';
        node?: {
          __typename?: 'PersonConsent';
          id: string;
          oid?: string | null;
          consentItemValues: Array<{
            __typename?: 'PersonConsentItemValue';
            communicationDataValues: Array<{
              __typename?: 'PersonConsentCommunicationDataValue';
              value?: string | null;
              consentCommunicationDataType: {
                __typename?: 'ConsentCommunicationDataType';
                oid: string;
                communicationDataType: {
                  __typename?: 'CommunicationDataType';
                  id: string;
                  baseType?: Types.CommunicationDataBaseType | null;
                };
              };
            }>;
          }>;
        } | null;
      }> | null;
    };
  } | null;
};

/**
 * __useGetPersonAvailableEmailsOrFaxesQuery__
 *
 * To run a query within a React component, call `useGetPersonAvailableEmailsOrFaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonAvailableEmailsOrFaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonAvailableEmailsOrFaxesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonAvailableEmailsOrFaxesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonAvailableEmailsOrFaxesQuery,
    GetPersonAvailableEmailsOrFaxesQueryVariables
  > &
    (
      | {
          variables: GetPersonAvailableEmailsOrFaxesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonAvailableEmailsOrFaxesQuery,
    GetPersonAvailableEmailsOrFaxesQueryVariables
  >(Operations.getPersonAvailableEmailsOrFaxes, options);
}
export function useGetPersonAvailableEmailsOrFaxesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonAvailableEmailsOrFaxesQuery,
    GetPersonAvailableEmailsOrFaxesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonAvailableEmailsOrFaxesQuery,
    GetPersonAvailableEmailsOrFaxesQueryVariables
  >(Operations.getPersonAvailableEmailsOrFaxes, options);
}
export function useGetPersonAvailableEmailsOrFaxesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonAvailableEmailsOrFaxesQuery,
        GetPersonAvailableEmailsOrFaxesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonAvailableEmailsOrFaxesQuery,
    GetPersonAvailableEmailsOrFaxesQueryVariables
  >(Operations.getPersonAvailableEmailsOrFaxes, options);
}
export type GetPersonAvailableEmailsOrFaxesQueryHookResult = ReturnType<
  typeof useGetPersonAvailableEmailsOrFaxesQuery
>;
export type GetPersonAvailableEmailsOrFaxesLazyQueryHookResult = ReturnType<
  typeof useGetPersonAvailableEmailsOrFaxesLazyQuery
>;
export type GetPersonAvailableEmailsOrFaxesSuspenseQueryHookResult = ReturnType<
  typeof useGetPersonAvailableEmailsOrFaxesSuspenseQuery
>;
export type GetPersonAvailableEmailsOrFaxesQueryResult = Apollo.QueryResult<
  GetPersonAvailableEmailsOrFaxesQuery,
  GetPersonAvailableEmailsOrFaxesQueryVariables
>;
